import { ReplenishmentArticle } from '@epicuro-next/models/cmi';
import { createAction, props } from '@ngrx/store';

export const getReplenishments = createAction(
  '[Replenishments] Get Replenishments',
  props<{ accountId: string }>(),
);
export const getReplenishmentsSuccess = createAction(
  '[Replenishments] Get Replenishments Success',
  props<{
    accountId: string;
    etag: string;
    articles: ReplenishmentArticle[];
  }>(),
);
export const getReplenishmentsFail = createAction(
  '[Replenishments] Get Replenishments Fail',
);
export const uploadReplenishmentUpdates = createAction(
  '[Replenishments] Upload replenishment updates',
  props<{ articles: ReplenishmentArticle[] }>(),
);
export const uploadReplenishmentUpdatesSuccess = createAction(
  '[Replenishments] Upload replenishment updates success',
  props<{ articles: ReplenishmentArticle[] }>(),
);
export const uploadReplenishmentUpdatesFailure = createAction(
  '[Replenishments] Upload replenishment updates failure',
);
